import { useEffect } from 'react'

export const useOnUnmount = (onUnmountFn: () => void) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => onUnmountFn, [])
}
